import { CALL_API } from "../../redux-store/middleware";
import { CONTENT_TYPE } from "../../utils/constant";
import { encodeBase64 } from "../../utils/utilityFunctions";
import { GET_SELF_DECLARATION_DOCUMENT, GET_SELF_DECLARATION_DOCUMENT_SUCCESS, GET_PROFILE_DETAILS, GET_PROFILE_DETAILS_SUCCESS, GET_SELF_DECLARE, GET_SELF_DECLARE_SUCCESS, getSelfDeclarationDocumentResponseBody, getProfileDetailsResponseBody, getSelfDeclarationResponseBody, IS_SELF_DECLARE, IS_SELF_DECLARE_SUCCESS, selfDeclarationRequestBody, selfReclarationResponseBody, SubbrokerDeclarationDocType, SUBBROKER_GENERATE_OTP, SUBBROKER_GENERATE_OTP_SUCCESS, SUBBROKER_VALIDATE_OTP, SUBBROKER_VALIDATE_OTP_SUCCESS, SUBBROKER_RESEND_OTP, SUBBROKER_RESEND_OTP_SUCCESS, SubbrokerGenerateOtpResponseBody, SubbrokerValidateOtpRequestBody, SubbrokerValidateOtpResponseBody, SubbrokerResendOtpRequestBody, SubbrokerResendOtpResponseBody, SubbrokerGenerateOtpRequestBody, SUBBROKER_REPORT_DOWNLOAD_SUCCESS, SUBBROKER_REPORT_DOWNLOAD } from "./types";

export const subbrokerSelfDeclaration =
  (body: selfDeclarationRequestBody, otpRef?: number) =>
    async (dispatch: any): Promise<selfReclarationResponseBody> => {
      const requestBody = otpRef
        ? {
          productDeclaration: body.productDeclaration.map((product) => ({
            ...product,
            otpRef,
          })),
        }
        : body;

      return await dispatch({
        [CALL_API]: {
          url: `/onboarding/onboarding/subbroker-self-declaration`,
          method: 'POST',
          types: [IS_SELF_DECLARE_SUCCESS, IS_SELF_DECLARE],
          body: requestBody,
          //body: { encryptedBody: encodeBase64(JSON.stringify(body)) }
        },
      });
    };


export const getSelfDeclaration =
  () =>
    async (dispatch: any): Promise<getSelfDeclarationResponseBody> => {
      return await dispatch({
        [CALL_API]: {
          url: `/onboarding/onboarding/subbroker-self-declaration`,
          method: 'GET',
          types: [GET_SELF_DECLARE_SUCCESS, GET_SELF_DECLARE],
        },
      });
    };

export const getProfileDetailsUserId =
  (body: { id: string }) =>
    async (dispatch: any): Promise<getProfileDetailsResponseBody> => {
      return await dispatch({
        [CALL_API]: {
          url: `/onboarding/onboarding/profile/${body.id}`,
          method: 'GET',
          types: [GET_PROFILE_DETAILS_SUCCESS, GET_PROFILE_DETAILS],
        },
      });
    };

export const getSelfDeclarationDocument =
  (body: { documentType: SubbrokerDeclarationDocType | string }) =>
    async (dispatch: any): Promise<getSelfDeclarationDocumentResponseBody> => {
      return await dispatch({
        [CALL_API]: {
          url: `/onboarding/onboarding/document/${body.documentType}`,
          method: 'GET',
          types: [GET_SELF_DECLARATION_DOCUMENT_SUCCESS, GET_SELF_DECLARATION_DOCUMENT],
        },
      });
    };



// Subbroker OTP Actions
export const subbrokerGenerateOtp =
  (body:SubbrokerGenerateOtpRequestBody) =>
    async (dispatch: any): Promise<SubbrokerGenerateOtpResponseBody> => {
      return await dispatch({
        [CALL_API]: {
          url: `/onboarding/transactions/generateOTPGeneric`,
          method: 'POST',
          types: [SUBBROKER_GENERATE_OTP_SUCCESS, SUBBROKER_GENERATE_OTP],
          body: { encryptedBody: encodeBase64(JSON.stringify(body)) }
        },
      });
    };

export const subbrokerValidateOtp =
  (body: SubbrokerValidateOtpRequestBody) =>
    async (dispatch: any): Promise<SubbrokerValidateOtpResponseBody> => {
      return await dispatch({
        [CALL_API]: {
          url: `/onboarding/transactions/verifyOTPGeneric`,
          method: 'POST',
          types: [SUBBROKER_VALIDATE_OTP_SUCCESS, SUBBROKER_VALIDATE_OTP],
          body: { encryptedBody: encodeBase64(JSON.stringify(body)) }
        },
      });
    };

export const subbrokerResendOtp =
  (body: SubbrokerResendOtpRequestBody) =>
    async (dispatch: any): Promise<SubbrokerResendOtpResponseBody> => {
      return await dispatch({
        [CALL_API]: {
          url: `/onboarding/transactions/resendOTPGeneric`,
          method: 'POST',
          types: [SUBBROKER_RESEND_OTP_SUCCESS, SUBBROKER_RESEND_OTP],
          body: { encryptedBody: encodeBase64(JSON.stringify(body)) }
        },
      });
    };

export const subbrokerReportDownload =
  (body: { isPDF: boolean; financialYear: string }) =>
    async (dispatch: any): Promise<any> => {
      return await dispatch({
        [CALL_API]: {
          url: `/onboarding/reports/declaration-report`,
          method: 'POST',
          types: [SUBBROKER_REPORT_DOWNLOAD_SUCCESS, SUBBROKER_REPORT_DOWNLOAD],
          body: { encryptedBody: encodeBase64(JSON.stringify(body)) },
          contentType: CONTENT_TYPE.EXCEL,
        },
      });
    };
